import { batchActions } from 'redux-batched-actions';

import * as Zap from 'app/entities/Zap';
import AppContainer from 'app/zap-mover/components/AppContainer';
import { fromAccountParam, toAccountParam } from 'app/zap-mover/Selectors';

const routes = {
  '/app/move-zaps': {
    onLeave({ router, dispatch }) {
      // If we're switching accounts the whole page/app will
      // refresh, but if we're not switching accounts then
      // this will be a regular in-app routing and we want to
      // clear out any excess entities from memory.
      if (!router.next.exit) {
        dispatch(
          batchActions([
            Zap.actions.resetCollectionEntities(),
            Zap.actions.resetMovingStatus(),
          ])
        );
      }
    },
    routes: {
      '.': AppContainer,
      [`from/:${fromAccountParam}`]: AppContainer,
      [`to/:${toAccountParam}`]: AppContainer,
      [`from/:${fromAccountParam}/to/:${toAccountParam}`]: AppContainer,
    },
  },
};

export default routes;
